module.exports = __webpack_public_path__ + "img/gy.bfbfc988.svg";